import { render, staticRenderFns } from "./FilterContent.vue?vue&type=template&id=b815974a&scoped=true&"
import script from "./FilterContent.vue?vue&type=script&lang=js&"
export * from "./FilterContent.vue?vue&type=script&lang=js&"
import style0 from "./FilterContent.vue?vue&type=style&index=0&id=b815974a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b815974a",
  null
  
)

export default component.exports